import { useTranslation } from "react-i18next";
import { ButtonLink } from "./Button";
import { useIsAdmin } from "../hooks/useIsAdmin";
import { getFirestoreConsoleUrlForPath } from "../config/firestoreConsole";

type Props = {
  path: string;
};

export const FirestoreConsoleButton = ({ path }: Props) => {
  const { t } = useTranslation();
  const isAdmin = useIsAdmin();
  if (!isAdmin || !path.trim()) {
    return null;
  }
  const href = getFirestoreConsoleUrlForPath(path);
  return (
    <ButtonLink href={href} target="_blank" rel="noopener noreferrer" $variant="outlined">
      {t("firebaseConsole.openDocument")}
    </ButtonLink>
  );
};
